import type { OrganizationResourceApi } from '@ingenico/api-sdk-device-management-private';
import type {
  OrganizationResourceReadApi,
  SearchRequestSortApi,
  SearchRequestSortOrderApi,
} from '@ingenico/api-sdk-provisioning-public';
import { searchFilterFilterType, searchOperator } from '@ingenico/api-sdk-provisioning-public';
import type { GridSortModel } from '@mui/x-data-grid';
import { toArray, toString, upperCase } from 'lodash-es';
import type {
  AppStoreOrganizationInfo,
  SearchOrganizationsV1MutationRequest,
} from '../domain/models/provisioningOrganizationList.model';

export function getAppStoreOrgTabCommonFilters(
  organizationIds?: string[],
): SearchOrganizationsV1MutationRequest['filters'] {
  return [
    {
      filterType: searchFilterFilterType.array,
      name: 'organization.id',
      operator: searchOperator.in,
      value: JSON.stringify(toArray(organizationIds)),
    },
  ];
}

export function getAuthorizedOrganizationsIds(data?: OrganizationResourceApi[]): string[] | undefined {
  return data?.filter(({ id }) => id)?.map((appAuthorizedOrganization) => toString(appAuthorizedOrganization.id));
}

export function getDisplayedAppStoreOrganizationTabInfo(
  data?: OrganizationResourceReadApi[],
): AppStoreOrganizationInfo[] | undefined {
  return data?.map((organization) => ({
    ...organization,
    activityType: organization.activityType === 'reseller' ? 'Merchant-aggregator' : organization.activityType,
  }));
}

export function transformOrganizationGridSortToRequestCall(gridSort: GridSortModel): SearchRequestSortApi {
  const [activeSort] = gridSort;
  return activeSort?.sort
    ? {
        field:
          activeSort.field === 'location'
            ? `organization.${activeSort.field}.city`
            : `organization.${activeSort.field}`,
        order: upperCase(activeSort.sort) as SearchRequestSortOrderApi,
      }
    : {};
}
